module.exports = __webpack_public_path__ + "static/media/icon_back.f972263e.svg";